import { Theme } from "@mui/material";
import { colors } from "../../theme/colors";

export const container = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "95vh",
});

export const bodyContainer = ({ breakpoints }: Theme) => ({
  width: { xs: "100%", sm: "500px" },
  height: "100%",
  background: colors.main_gradient,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: { xs: "50px 50px 0 0", sm: "50px" },
  mt: "90px",
  py: "80px",
  boxShadow: {
    sm: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);",
  },
});

export const subContainer = ({ breakpoints }: Theme) => ({
  mx: "30px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: { xs: "350px", sm: "440px" },
});

export const titleText = ({ breakpoints }: Theme) => ({
  color: "white",
  fontSize: "24px",
  fontWeight: 600,
  textAlign: "center",
});

export const divider = ({ breakpoints }: Theme) => ({
  width: "100%",
  "&::before, &::after": {
    borderColor: colors.light_gray,
  },
  color: colors.dark_gray,
  mt: 1,
  marginBottom: 7,
});

export const authButton = ({ breakpoints }: Theme) => ({
  mt: 4,
  mb: 2,
  backgroundColor: colors.main,
  "&:hover": {
    backgroundColor: colors.main,
  },
  fontWeight: 600,
});

export const modalContainer = ({ breakpoints }: Theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 320,
  // height: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "16px",
  p: 2,
});

export const input = ({ breakpoints }: Theme) => ({
  mt: 1,
  borderRadius: 4,
  input: {
    background: "white",
    borderRadius: "6px",
  },
});

export const itemText = ({ breakpoints }: Theme) => ({
  color: colors.main,
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "27px",
  mt: 3,
});

export const payButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.main,
  "&:hover": {
    backgroundColor: colors.main,
  },
  margin: "20px 0",
  height: "40px",
  fontWeight: "500",
  fontSize: "16px",
});

export const cardItemText = ({ breakpoints }: Theme) => ({
  color: colors.main,
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "27px",
  mt: 3,
  textAlign: "center",
});

export const backButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.light_black,
  "&:hover": {
    backgroundColor: colors.light_black,
  },
  margin: "30px 0 10px 0",
  width: "150px",
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
});
